module.exports = __webpack_public_path__ + "static/casa-cond-verde-e0a25208352e3767e05bfcf743f9d001.jpg";